import { css } from '@emotion/react';
import { Icon, IconName } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Chip, ChipVariants } from '@frontend/design-system';

type StatusInfo = {
  text: string;
  variant: ChipVariants;
  iconName: IconName;
};

type InsuranceStatusChipProps = {
  statusInfo: StatusInfo;
};

export const InsuranceStatusChip = ({ statusInfo }: InsuranceStatusChipProps) => {
  if (!statusInfo?.text) return '-';

  return (
    <Chip
      variant={statusInfo.variant}
      css={chipStyles}
      leftElement={<Icon name={statusInfo.iconName} css={{ color: 'currentcolor' }} />}
    >
      {statusInfo.text}
    </Chip>
  );
};

const chipStyles = css({
  width: 'fit-content',
  maxWidth: theme.spacing(16),
});
